<div [ngClass]="{ 'dark text-white-dark': store.semidark }">
  <nav class="sidebar fixed bottom-0 top-0 z-50 h-full w-[280px] shadow-[5px_0_25px_0_rgba(94,92,154,0.1)] transition-all duration-300">
    <div class="h-full min-h-screen bg-[#0E121B] pb-5">
      <div class="flex items-center justify-between px-4 py-3">
        <a (click)="navigateToTenant()" class="main-logo flex shrink-0 items-center">
          <img class="w-7 flex-none" src="/assets/favicon.png" alt="" />
          <span class="align-middle text-2xl font-bold text-white dark:text-white-light lg:inline ltr:ml-1.5 rtl:mr-1.5"
            >Source<span class="text-[#068CFE]">by</span></span
          >
        </a>
        <a
          href="javascript:;"
          class="collapse-icon flex h-8 w-8 items-center rounded-full text-white transition duration-300 hover:bg-gray-500/10 hover:text-primary dark:text-white-light dark:hover:bg-dark-light/10 rtl:rotate-180"
          (click)="storeData.dispatch({ type: 'toggleSidebar'})"
        >
          <svg class="m-auto h-5 w-5" width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M13 19L7 12L13 5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            <path opacity="0.5" d="M16.9998 19L10.9998 12L16.9998 5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
        </a>
      </div>
      <div class="relative !h-[calc(100vh-80px)]" appearance="compact" #sidebarScroll>
        <ul class="relative space-y-0.5 p-2 py-0 font-semibold">
          <!-- dashboard -->
          <li class="accordion menu nav-item">
            <button
              type="button"
              class="nav-link group w-full"
              routerLink="/dashboard"
              routerLinkActive="active"
              [routerLinkActiveOptions]="{ exact: false }"
              (click)="onNavClick('Dashboard', $event)"
              [attr.data-tooltip]="isCollapsed ? 'Dashboard' : null"
            >
              <div class="flex items-center justify-center">
                <icon-menu-dashboard class="shrink-0 !text-[#C6C7C9] group-hover:!text-[#ffffff]"></icon-menu-dashboard>
                <span class="menu-name text-white dark:text-[#506690] dark:group-hover:text-white-dark ltr:pl-3 rtl:pr-3">Dashboard</span>
              </div>
            </button>
          </li>
          <!-- Tenant -->
          <li class="accordion menu nav-item" *appHasPermission="'list_tenants'">
            <button
              type="button"
              class="nav-link group w-full"
              routerLink="/tenant"
              routerLinkActive="active"
              [routerLinkActiveOptions]="{ exact: false }"
              (click)="onNavClick('Organizations', $event); navigateToTenant()"
              [attr.data-tooltip]="isCollapsed ? 'Organizations' : null"
            >
              <div class="flex items-center justify-center">
                <svg
                  class="shrink-0 !text-[#C6C7C9] group-hover:!text-[#ffffff]"
                  width="21"
                  height="21"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M3 9C3 6.17157 3 4.75736 3.87868 3.87868C4.75736 3 6.17157 3 9 3H15C17.8284 3 19.2426 3 20.1213 3.87868C21 4.75736 21 6.17157 21 9V15C21 17.8284 21 19.2426 20.1213 20.1213C19.2426 21 17.8284 21 15 21H9C6.17157 21 4.75736 21 3.87868 20.1213C3 19.2426 3 17.8284 3 15V9Z"
                    stroke="currentColor"
                    stroke-width="1.5"
                  />
                  <path d="M7 3V21" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
                  <path d="M3 12H21" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
                </svg>
                <span class="menu-name text-white dark:text-[#506690] dark:group-hover:text-white-dark ltr:pl-3 rtl:pr-3">Organizations</span>
              </div>
            </button>
          </li>
          <!-- Buyer Management -->
          <li class="accordion menu nav-item" *appHasPermission="'list_buyers'">
            <button
              type="button"
              class="nav-link group w-full"
              routerLink="/buyer-master/buyer-list"
              routerLinkActive="active"
              [routerLinkActiveOptions]="{ exact: false }"
              (click)="onNavClick('Buyers', $event); navigateToBuyerManagement()"
              [attr.data-tooltip]="isCollapsed ? 'Buyers' : null"
            >
              <div class="flex items-center justify-center">
                <svg class="shrink-0 !text-[#C6C7C9] group-hover:!text-[#ffffff]" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
                  <path
                    id="bm"
                    d="M17.5,9.167H13.333a2.5,2.5,0,0,0-2.5,2.5V17.5a2.5,2.5,0,0,0,2.5,2.5H17.5A2.5,2.5,0,0,0,20,17.5V11.667A2.5,2.5,0,0,0,17.5,9.167Zm.833,8.333a.834.834,0,0,1-.833.833H13.333A.834.834,0,0,1,12.5,17.5V11.667a.834.834,0,0,1,.833-.833H17.5a.834.834,0,0,1,.833.833ZM17.5,13.331a.833.833,0,0,1-.833.833h-2.5a.833.833,0,0,1,0-1.667h2.5A.833.833,0,0,1,17.5,13.331Zm0,2.5a.833.833,0,0,1-.833.833h-2.5a.833.833,0,1,1,0-1.667h2.5A.833.833,0,0,1,17.5,15.833ZM7.5,10a5,5,0,1,0-5-5A5.005,5.005,0,0,0,7.5,10Zm0-8.333A3.333,3.333,0,1,1,4.167,5,3.337,3.337,0,0,1,7.5,1.667ZM9.167,12.5a.833.833,0,0,1-.833.833H7.5a5.84,5.84,0,0,0-5.833,5.833.833.833,0,1,1-1.667,0,7.509,7.509,0,0,1,7.5-7.5h.833A.833.833,0,0,1,9.167,12.5Z"
                    fill="#c6c7c9"
                  />
                </svg>
                <span class="menu-name text-white dark:text-[#506690] dark:group-hover:text-white-dark ltr:pl-3 rtl:pr-3">Buyers</span>
              </div>
            </button>
          </li>
          <!-- Supplier -->
          @if(permissionService.hasPermission('vendor_list')){
          <li class="accordion menu nav-item">
            <button
              type="button"
              class="nav-link group w-full"
              routerLink="/vendor-master/vendor-list"
              routerLinkActive="active"
              [routerLinkActiveOptions]="{ exact: false }"
              (click)="onNavClick('Suppliers', $event); navigateToVendorManagement()"
              [attr.data-tooltip]="isCollapsed ? 'Suppliers' : null"
            >
              <div class="flex items-center justify-center">
                <svg class="shrink-0 !text-[#C6C7C9] group-hover:!text-[#ffffff]" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
                  <path
                    id="vm"
                    d="M19.994,13.588A1.589,1.589,0,0,1,18.463,15h-.516A1.61,1.61,0,0,1,16.4,13.333,1.61,1.61,0,0,1,14.85,15h-.516a1.61,1.61,0,0,1-1.548-1.667A1.61,1.61,0,0,1,11.237,15h-.516A1.59,1.59,0,0,1,9.19,13.588a.951.951,0,0,1,.079-.491l.3-.717a2.5,2.5,0,0,1,2.312-1.547h5.428a2.5,2.5,0,0,1,2.312,1.547l.3.717a.943.943,0,0,1,.079.491Zm-1.649,2.245a.833.833,0,0,0-.834.833V17.5a.834.834,0,0,1-.834.833H12.508a.834.834,0,0,1-.834-.833v-.833a.834.834,0,0,0-1.668,0V17.5a2.5,2.5,0,0,0,2.5,2.5h4.169a2.5,2.5,0,0,0,2.5-2.5v-.833A.833.833,0,0,0,18.345,15.833ZM1.668,5a5,5,0,1,1,5,5A5.007,5.007,0,0,1,1.668,5ZM3.335,5A3.335,3.335,0,1,0,6.671,1.667,3.338,3.338,0,0,0,3.335,5Zm3.335,6.667A6.677,6.677,0,0,0,0,18.333v.833a.834.834,0,0,0,1.668,0v-.833a5.007,5.007,0,0,1,5-5,.833.833,0,1,0,0-1.667Z"
                    fill="#c6c7c9"
                  />
                </svg>

                <span class="menu-name text-white dark:text-[#506690] dark:group-hover:text-white-dark ltr:pl-3 rtl:pr-3">Suppliers</span>
              </div>
            </button>
          </li>
          }
          <!-- Supplier Verification -->
          @if(permissionService.hasPermission('vendor_kyc_verification_list') || permissionService.hasPermission('review_vendor_kyc') ||
          permissionService.hasPermission('view_only_vendor_kyc') ){
          <li class="accordion menu nav-item">
            <button
              type="button"
              class="nav-link group w-full"
              routerLink="/vendor-kyc-master/vendor-kyc-list"
              routerLinkActive="active"
              [routerLinkActiveOptions]="{ exact: false }"
              (click)="onNavClick('Supplier Verification', $event); navigateToVendorVerificationKYC()"
              [attr.data-tooltip]="isCollapsed ? 'Supplier Verification' : null"
            >
              <div class="flex items-center justify-center">
                <svg class="shrink-0 !text-[#C6C7C9] group-hover:!text-[#ffffff]" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
                  <path
                    id="kyc"
                    d="M14.583,20A5.417,5.417,0,1,1,20,14.583,5.423,5.423,0,0,1,14.583,20Zm0-9.167a3.75,3.75,0,1,0,3.75,3.75A3.755,3.755,0,0,0,14.583,10.833Zm.833,5.295L16.987,14.6a.833.833,0,1,0-1.161-1.195L14.25,14.937a.213.213,0,0,1-.3,0l-.73-.715a.834.834,0,0,0-1.166,1.192l.73.715a1.889,1.889,0,0,0,2.634,0ZM7.5,10a5,5,0,1,1,5-5,5.005,5.005,0,0,1-5,5Zm0-8.333A3.333,3.333,0,1,0,10.833,5,3.337,3.337,0,0,0,7.5,1.667Zm-5.833,17.5a5.838,5.838,0,0,1,5.1-5.788.833.833,0,1,0-.206-1.653A7.506,7.506,0,0,0,0,19.167a.833.833,0,1,0,1.667,0Z"
                    fill="#c6c7c9"
                  />
                </svg>
                <span class="menu-name text-white dark:text-[#506690] dark:group-hover:text-white-dark ltr:pl-3 rtl:pr-3">Supplier Verification</span>
              </div>
            </button>
          </li>
          }
          <!-- Users -->
          <li class="accordion menu nav-item" *appHasPermission="'list_team_users'">
            <button
              type="button"
              class="nav-link group w-full"
              routerLink="/team-master/user-list"
              routerLinkActive="active"
              [routerLinkActiveOptions]="{ exact: false }"
              (click)="onNavClick('Users', $event); navigateToTeamManagement()"
              [attr.data-tooltip]="isCollapsed ? 'Users' : null"
            >
              <div class="flex items-center justify-center">
                <svg class="shrink-0 !text-[#C6C7C9] group-hover:!text-[#ffffff]" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
                  <path
                    id="team-man"
                    d="M10,13.333A3.333,3.333,0,1,1,13.333,10,3.333,3.333,0,0,1,10,13.333Zm0-5A1.667,1.667,0,1,0,11.667,10,1.667,1.667,0,0,0,10,8.333Zm5,10.833a5,5,0,0,0-10,0,.833.833,0,1,0,1.667,0,3.333,3.333,0,0,1,6.667,0,.833.833,0,1,0,1.667,0Zm0-12.5a3.333,3.333,0,1,1,3.333-3.333A3.333,3.333,0,0,1,15,6.667Zm0-5a1.667,1.667,0,1,0,1.667,1.667A1.667,1.667,0,0,0,15,1.667ZM20,12.5a5.005,5.005,0,0,0-5-5,.833.833,0,1,0,0,1.667A3.333,3.333,0,0,1,18.333,12.5.833.833,0,0,0,20,12.5ZM5,6.667A3.333,3.333,0,1,1,8.333,3.333,3.333,3.333,0,0,1,5,6.667Zm0-5A1.667,1.667,0,1,0,6.667,3.333,1.667,1.667,0,0,0,5,1.667ZM1.667,12.5A3.333,3.333,0,0,1,5,9.167.833.833,0,0,0,5,7.5a5,5,0,0,0-5,5,.833.833,0,0,0,1.667,0Z"
                    fill="#c6c7c9"
                  />
                </svg>
                <span class="menu-name text-white dark:text-[#506690] dark:group-hover:text-white-dark ltr:pl-3 rtl:pr-3">Users</span>
              </div>
            </button>
          </li>
          <!-- support (hidden from left nav) -->
          @if (false) {
          <li class="accordion menu nav-item">
            <button
              type="button"
              class="nav-link group w-full"
              routerLink="/support-master/support-helpdesk-list"
              routerLinkActive="active"
              [routerLinkActiveOptions]="{ exact: false }"
              (click)="onNavClick('Support', $event); navigateToSupport()"
              [attr.data-tooltip]="isCollapsed ? 'Support' : null"
            >
              <div class="flex items-center justify-center">
                <svg
                  class="shrink-0 !text-[#C6C7C9] group-hover:!text-[#ffffff]"
                  xmlns="http://www.w3.org/2000/svg"
                  width="17.294"
                  height="22"
                  viewBox="0 0 17.294 22"
                >
                  <path
                    id="support"
                    d="M8.011,8.708a3.187,3.187,0,0,0,.326,1.409,3.638,3.638,0,0,0-.766,2.068,5.043,5.043,0,1,1,8.573-4.573,5.173,5.173,0,0,1,.083,1.678.913.913,0,0,1-.914.794h-.041a.891.891,0,0,1-.864-1.022,3.288,3.288,0,0,0-.073-1.13,3.21,3.21,0,0,0-6.324.777ZM4.445,7.521a6.88,6.88,0,0,1,7.233-5.673,7.033,7.033,0,0,1,6.415,7.21,2.925,2.925,0,0,1-2.941,2.858H12.947a1.829,1.829,0,1,0-.482,1.833h2.688a4.753,4.753,0,0,0,4.774-4.641A8.869,8.869,0,0,0,11.8.019,8.625,8.625,0,0,0,5.265,2.355,8.745,8.745,0,0,0,2.648,7.182a.917.917,0,0,0,.907,1.069.9.9,0,0,0,.891-.729Zm6.774,8.062A7.539,7.539,0,0,0,3.927,20.81a.917.917,0,1,0,1.75.546,5.787,5.787,0,0,1,5.541-3.94,5.786,5.786,0,0,1,5.541,3.94.917.917,0,0,0,.875.644.945.945,0,0,0,.273-.041.918.918,0,0,0,.6-1.149,7.539,7.539,0,0,0-7.292-5.227Z"
                    transform="translate(-2.634)"
                    fill="#c6c7c9"
                  />
                </svg>
                <span class="menu-name text-white dark:text-[#506690] dark:group-hover:text-white-dark ltr:pl-3 rtl:pr-3">Support</span>
              </div>
            </button>
          </li>
          }

          <!-- Department Management -->
          <li class="accordion menu nav-item" *appHasPermission="'list_departments'">
            <button
              type="button"
              class="nav-link group w-full"
              routerLink="/department-master/department-list"
              routerLinkActive="active"
              [routerLinkActiveOptions]="{ exact: false }"
              (click)="onNavClick('Departments', $event); navigateToDepartmentManagement()"
              [attr.data-tooltip]="isCollapsed ? 'Departments' : null"
            >
              <div class="flex items-center justify-center">
                <svg
                  class="shrink-0 !text-[#C6C7C9] group-hover:!text-[#ffffff]"
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <g clip-path="url(#clip0_2107_277)">
                    <path
                      d="M24 18.5V20.5C24 22.43 22.43 24 20.5 24H3.5C1.57 24 0 22.43 0 20.5V18.5C0 16.57 1.57 15 3.5 15H5.5C6.053 15 6.5 15.447 6.5 16C6.5 16.553 6.053 17 5.5 17H3.5C2.673 17 2 17.673 2 18.5V20.5C2 21.327 2.673 22 3.5 22H20.5C21.327 22 22 21.327 22 20.5V18.5C22 17.673 21.327 17 20.5 17H18.5C17.947 17 17.5 16.553 17.5 16C17.5 15.447 17.947 15 18.5 15H20.5C22.43 15 24 16.57 24 18.5ZM24 3.5V4.5C24 6.43 22.43 8 20.5 8H20V9C20 10.654 18.654 12 17 12H13V15.395L14.295 14.101C14.686 13.71 15.318 13.71 15.709 14.101C16.1 14.492 16.1 15.124 15.709 15.515L13.234 17.991C12.554 18.67 11.45 18.671 10.77 17.991L8.294 15.515C7.903 15.124 7.903 14.492 8.294 14.101C8.685 13.71 9.317 13.71 9.708 14.101L11 15.393V11.999H7C5.346 11.999 4 10.653 4 8.999V7.999H3.5C1.57 7.999 0 6.429 0 4.499V3.499C0 1.57 1.57 0 3.5 0H6.5C8.43 0 10 1.57 10 3.5V4.5C10 6.43 8.43 8 6.5 8H6V9C6 9.551 6.448 10 7 10H17C17.552 10 18 9.551 18 9V8H17.5C15.57 8 14 6.43 14 4.5V3.5C14 1.57 15.57 0 17.5 0H20.5C22.43 0 24 1.57 24 3.5ZM6.5 6C7.327 6 8 5.327 8 4.5V3.5C8 2.673 7.327 2 6.5 2H3.5C2.673 2 2 2.673 2 3.5V4.5C2 5.327 2.673 6 3.5 6H6.5ZM22 3.5C22 2.673 21.327 2 20.5 2H17.5C16.673 2 16 2.673 16 3.5V4.5C16 5.327 16.673 6 17.5 6H20.5C21.327 6 22 5.327 22 4.5V3.5Z"
                      fill="#C6C7C9"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_2107_277">
                      <rect width="24" height="24" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
                <span class="menu-name text-white dark:text-[#506690] dark:group-hover:text-white-dark ltr:pl-3 rtl:pr-3"> Departments</span>
              </div>
            </button>
          </li>

          <!-- Categories -->
          <li class="accordion menu nav-item" *appHasPermission="'list_categories'">
            <button
              type="button"
              class="nav-link group w-full"
              routerLink="/category-master/category-list"
              routerLinkActive="active"
              [routerLinkActiveOptions]="{ exact: false }"
              (click)="onNavClick('Categories', $event); navigateToCategoryManagement()"
              [attr.data-tooltip]="isCollapsed ? 'Categories' : null"
            >
              <div class="flex items-center justify-center">
                <svg
                  class="shrink-0 !text-[#C6C7C9] group-hover:!text-[#ffffff]"
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <path
                    d="M4 5C4 3.89543 4.89543 3 6 3H10C11.1046 3 12 3.89543 12 5V9C12 10.1046 11.1046 11 10 11H6C4.89543 11 4 10.1046 4 9V5Z"
                    fill="#C6C7C9"
                  />
                  <path
                    d="M4 15C4 13.8954 4.89543 13 6 13H10C11.1046 13 12 13.8954 12 15V19C12 20.1046 11.1046 21 10 21H6C4.89543 21 4 20.1046 4 19V15Z"
                    fill="#C6C7C9"
                  />
                  <path
                    d="M14 5C14 3.89543 14.8954 3 16 3H18C19.1046 3 20 3.89543 20 5V7C20 8.10457 19.1046 9 18 9H16C14.8954 9 14 8.10457 14 7V5Z"
                    fill="#C6C7C9"
                  />
                  <path
                    d="M14 11C14 9.89543 14.8954 9 16 9H18C19.1046 9 20 9.89543 20 11V19C20 20.1046 19.1046 21 18 21H16C14.8954 21 14 20.1046 14 19V11Z"
                    fill="#C6C7C9"
                  />
                </svg>
                <span class="menu-name text-white dark:text-[#506690] dark:group-hover:text-white-dark ltr:pl-3 rtl:pr-3"> Categories</span>
              </div>
            </button>
          </li>
        </ul>

        <!-- profile -->
        <div class="absolute bottom-0 left-3.5">
          <div class="dropdown shrink-0">
            <div hlMenu class="!block">
              <button type="button" hlMenuButton class="group relative block">
                @if (userProfileImageUrl) {
                <img
                  [src]="userProfileImageUrl"
                  (error)="authService.onImageError($event, userData?.full_name)"
                  [fallbackSize]="32"
                  fallbackBgColor="#E3EAFD"
                  fallbackTextColor="#2B3674"
                  alt="Profile"
                  class="h-8 w-8 shrink-0 rounded-full object-cover saturate-50 group-hover:saturate-100"
                />
                } @else {
                <div
                  class="relative flex h-8 w-8 shrink-0 cursor-pointer items-center justify-center rounded-full bg-gradient-to-br from-blue-500 to-purple-600 text-white shadow-lg transition-transform duration-300 group-hover:scale-105"
                >
                  <span class="inline-flex h-8 w-8 items-center justify-center rounded-full text-[11px] font-semibold text-white">
                    {{ imageService.getInitials(userData?.full_name) }}
                  </span>
                </div>
                }
              </button>
              <ul *hlMenuItems @toggleAnimation class="absolute bottom-12 left-0 z-50 w-[230px] !py-0 font-semibold text-primary">
                <div class="flex items-center px-1.5 py-4">
                  <div class="flex-none">
                    @if(userProfileImageUrl){
                    <img
                      [src]="userProfileImageUrl"
                      [appFallbackImage]="imageService.getInitials(userData?.full_name)"
                      [fallbackSize]="32"
                      fallbackBgColor="#E3EAFD"
                      fallbackTextColor="#2B3674"
                      alt="Profile"
                      class="h-8 w-8 rounded-full object-cover"
                      (error)="authService.onImageError($event, userData?.full_name)"
                    />
                    }@else{
                    <div
                      class="flex h-8 w-8 items-center justify-center rounded-full border-2 border-gray-200 bg-gradient-to-br from-blue-500 to-purple-600 text-white shadow-lg transition-transform duration-300 dark:border-gray-600 sm:h-10 sm:w-10"
                    >
                      <span class="text-xs font-semibold text-white shadow-sm"> {{ imageService.getInitials(userData?.full_name) }} </span>
                    </div>
                    }
                  </div>
                  <div class="flex flex-col">
                    <div class="truncate ltr:pl-4 rtl:pr-4">
                      <h4 class="text-base">{{ userData?.full_name }}</h4>
                      <a class="text-black/60 hover:text-primary dark:text-dark-light/60 dark:hover:text-white" href="javascript:;">{{ userData?.email_id }}</a>
                    </div>
                  </div>
                </div>
                <li>
                  <a routerLink="/admin/profile" class="cursor-pointer border-t border-gray-200 pt-2 text-primary dark:border-white/10">
                    <svg
                      class="h-4.5 w-4.5 shrink-0 ltr:mr-2 rtl:ml-2"
                      width="18"
                      height="18"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <circle cx="12" cy="6" r="4" stroke="currentColor" stroke-width="1.5" />
                      <path
                        opacity="0.5"
                        d="M20 17.5C20 19.9853 20 22 12 22C4 22 4 19.9853 4 17.5C4 15.0147 7.58172 13 12 13C16.4183 13 20 15.0147 20 17.5Z"
                        stroke="currentColor"
                        stroke-width="1.5"
                      />
                    </svg>

                    View Profile
                  </a>
                </li>
                <li class="border-t border-white-light dark:border-white-light/10">
                  <a (click)="signOut()" class="cursor-pointer !py-3 text-primary">
                    <svg
                      class="h-4.5 w-4.5 shrink-0 rotate-90 ltr:mr-2 rtl:ml-2"
                      width="18"
                      height="18"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        opacity="0.5"
                        d="M17 9.00195C19.175 9.01406 20.3529 9.11051 21.1213 9.8789C22 10.7576 22 12.1718 22 15.0002V16.0002C22 18.8286 22 20.2429 21.1213 21.1215C20.2426 22.0002 18.8284 22.0002 16 22.0002H8C5.17157 22.0002 3.75736 22.0002 2.87868 21.1215C2 20.2429 2 18.8286 2 16.0002L2 15.0002C2 12.1718 2 10.7576 2.87868 9.87889C3.64706 9.11051 4.82497 9.01406 7 9.00195"
                        stroke="currentColor"
                        stroke-width="1.5"
                        stroke-linecap="round"
                      />
                      <path d="M12 15L12 2M12 2L15 5.5M12 2L9 5.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                    Sign Out
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </nav>
</div>
